// import React, { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import Layouts from "./layouts/layout";
// import { getWeeklyLeaderboard, getFinalLeaderboard } from "../services/home";
// import styles from "./css/promoLeaderboard.module.css";

// // ===================== EMPTY DATA (until the API responds) =====================
// const emptyLeaderboard = {
//   week: "",
//   startDate: "",
//   endDate: "",
//   players: [],
//   myPosition: {
//     rank: null,
//     points: 0,
//     prize: null,
//     eligible: true,
//     ineligibleReason: null,
//     ineligibleMessage: null,
//   },
// };

// const TOP_LIMIT = 5;

// // ===================== TEXT (0 = English, 3 = Portuguese) =====================
// const leaderboardText = {
//   0: {
//     title: "Leaderboard",
//     weekTab: "This week",
//     finalTab: "Final ranking",
//     week: "Week",
//     weekNote: "Only this week's stars count.",
//     finalNote: "Total stars across all four weeks.",
//     eligibilityNote: "Weekly prizes go to eligible players only: no prizes in consecutive weeks and a maximum of 2 weekly prizes per player.",
//     points: "stars",
//     yourPosition: "Your position:",
//     yourPrize: "Provisional prize:",
//     notEligible: "Not eligible",
//     reasons: {
//       WON_PREVIOUS_WEEK: "Won a prize last week",
//       MAX_PRIZES_REACHED: "Already won 2 weekly prizes",
//     },
//     movedPrizes: "Prize passed to the next eligible player",
//     back: "Go back",
//     loading: "Loading leaderboard...",
//     noPlayers: "No players yet. Play now to be the first!",
//   },
//   3: {
//     title: "Classificação",
//     weekTab: "Esta semana",
//     finalTab: "Classificação final",
//     week: "Semana",
//     weekNote: "Contam apenas as estrelas desta semana.",
//     finalNote: "Soma das estrelas das quatro semanas.",
//     eligibilityNote: "Os prémios semanais vão apenas para jogadores elegíveis: sem prémios em semanas consecutivas e no máximo 2 prémios semanais por jogador.",
//     points: "estrelas",
//     yourPosition: "A tua posição:",
//     yourPrize: "Prémio provisório:",
//     notEligible: "Não elegível",
//     reasons: {
//       WON_PREVIOUS_WEEK: "Ganhou um prémio na semana passada",
//       MAX_PRIZES_REACHED: "Já ganhou 2 prémios semanais",
//     },
//     movedPrizes: "Prémio passado ao próximo jogador elegível",
//     back: "Voltar",
//     loading: "A carregar classificação...",
//     noPlayers: "Ainda não há jogadores. Joga agora e sê o primeiro!",
//   },
// };

// // formats 2840 -> "2.840" (same style as the MT amounts)
// const formatPoints = (value) =>
//   (value || 0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");

// const avatarColors = ["#f6c6b8", "#c9d8f5", "#d6eccd", "#f3dfa8", "#e3cdf2"];

// const PlayerAvatar = ({ player }) => {
//   const [imgError, setImgError] = useState(false);

//   if (player.avatar && !imgError) {
//     return (
//       <img
//         src={player.avatar}
//         alt=""
//         className={styles.avatar}
//         onError={() => setImgError(true)}
//       />
//     );
//   }

//   return (
//     <span
//       className={styles.avatar}
//       style={{ background: avatarColors[player.rank % avatarColors.length] }}
//       aria-hidden="true"
//     >
//       {player.name ? player.name.charAt(0) : "?"}
//     </span>
//   );
// };

// const PromoLeaderboard = () => {
//   const navigate = useNavigate();
//   const [activeTab, setActiveTab] = useState("week");
//   const [weeklyLeaderboard, setWeeklyLeaderboard] = useState(emptyLeaderboard);
//   const [finalLeaderboard, setFinalLeaderboard] = useState(emptyLeaderboard);
//   const [loading, setLoading] = useState(true);
//   const language = localStorage.getItem("selectedLanguage");
//   const text = leaderboardText[language] || leaderboardText["0"];
//   const msgLang = language === "3" ? "pt" : "en";

//   // ===================== FETCH LEADERBOARDS =====================
//   useEffect(() => {
//     Promise.all([getWeeklyLeaderboard(), getFinalLeaderboard()])
//       .then(([weeklyRes, finalRes]) => {
//         if (weeklyRes?.result) setWeeklyLeaderboard(weeklyRes.result);
//         if (finalRes?.result) setFinalLeaderboard(finalRes.result);
//         setLoading(false);
//       })
//       .catch((err) => {
//         console.log(err);
//         setLoading(false);
//       });
//   }, []);

//   const isWeek = activeTab === "week";
//   const data = isWeek ? weeklyLeaderboard : finalLeaderboard;
//   const players = data.players || [];
//   const my = data.myPosition || emptyLeaderboard.myPosition;
//   // eligibility rules apply to the weekly tab only
//   const myIneligible = isWeek && my.eligible === false;

//   const rankClass = (rank) => {
//     if (rank === 1) return styles.rankGold;
//     if (rank === 2) return styles.rankSilver;
//     if (rank === 3) return styles.rankBronze;
//     return styles.rankPlain;
//   };

//   return (
//     <Layouts>
//       <div className={styles.page}>
//         {/* ===================== HEADER WITH BACK ARROW ===================== */}
//         <div className={styles.header}>
//           <button
//             type="button"
//             className={styles.backButton}
//             onClick={() => navigate(-1)}
//             aria-label={text.back}
//           >
//             <svg
//               viewBox="0 0 24 24"
//               fill="none"
//               stroke="currentColor"
//               strokeWidth="2.5"
//               strokeLinecap="round"
//               strokeLinejoin="round"
//               aria-hidden="true"
//             >
//               <polyline points="15 18 9 12 15 6" />
//             </svg>
//           </button>
//           <h2 className={styles.title}>{text.title}</h2>
//         </div>

//         {/* ===================== TABS ===================== */}
//         <div className={styles.tabs} role="tablist">
//           <button
//             type="button"
//             role="tab"
//             aria-selected={activeTab === "week"}
//             className={`${styles.tab} ${activeTab === "week" ? styles.tabActive : ""}`}
//             onClick={() => setActiveTab("week")}
//           >
//             {text.weekTab}
//           </button>
//           <button
//             type="button"
//             role="tab"
//             aria-selected={activeTab === "final"}
//             className={`${styles.tab} ${activeTab === "final" ? styles.tabActive : ""}`}
//             onClick={() => setActiveTab("final")}
//           >
//             {text.finalTab}
//           </button>
//         </div>

//         {loading ? (
//           <p
//             className={styles.periodNote}
//             style={{ textAlign: "center", margin: "32px 0" }}
//           >
//             {text.loading}
//           </p>
//         ) : (
//           <>
//             {/* ===================== PERIOD INFO ===================== */}
//             <div className={styles.period}>
//               <svg
//                 className={styles.periodIcon}
//                 viewBox="0 0 24 24"
//                 fill="none"
//                 stroke="currentColor"
//                 strokeWidth="2"
//                 strokeLinecap="round"
//                 strokeLinejoin="round"
//                 aria-hidden="true"
//               >
//                 <rect x="3" y="4" width="18" height="18" rx="2" />
//                 <line x1="16" y1="2" x2="16" y2="6" />
//                 <line x1="8" y1="2" x2="8" y2="6" />
//                 <line x1="3" y1="10" x2="21" y2="10" />
//                 <line x1="8" y1="15" x2="10" y2="15" />
//               </svg>
//               <div>
//                 <p className={styles.periodTitle}>
//                   {isWeek
//                     ? `${text.week} ${data.week} • ${data.startDate}–${data.endDate}`
//                     : `${data.startDate} – ${data.endDate}`}
//                 </p>
//                 <p className={styles.periodNote}>
//                   {isWeek ? text.weekNote : text.finalNote}
//                 </p>
//                 {isWeek && (
//                   <p className={styles.eligibilityNote}>ℹ️ {text.eligibilityNote}</p>
//                 )}
//               </div>
//             </div>

//             {/* ===================== PLAYER LIST ===================== */}
//             {players.length === 0 ? (
//               <p
//                 className={styles.periodNote}
//                 style={{ textAlign: "center", margin: "24px 0" }}
//               >
//                 {text.noPlayers}
//               </p>
//             ) : (
//               <ul className={styles.list}>
//                 {players.map((player, index) => {
//                   const ineligible = isWeek && player.eligible === false;
//                   // divider before the first prize holder below the top 5
//                   const showMovedDivider =
//                     isWeek &&
//                     player.rank > TOP_LIMIT &&
//                     (index === 0 || players[index - 1].rank <= TOP_LIMIT);

//                   return (
//                     <React.Fragment key={player.id}>
//                       {showMovedDivider && (
//                         <li className={styles.movedDivider} aria-hidden="true">
//                           <span>↓ {text.movedPrizes}</span>
//                         </li>
//                       )}
//                       <li className={`${styles.row} ${ineligible ? styles.rowIneligible : ""}`}>
//                         <span
//                           className={`${styles.rank} ${rankClass(player.rank)}`}
//                         >
//                           {player.rank}
//                         </span>
//                         <PlayerAvatar player={player} />
//                         <div className={styles.playerInfo}>
//                           <p className={styles.playerName}>{player.name}</p>
//                           <p className={styles.playerPoints}>
//                             {formatPoints(player.points)} {text.points}
//                           </p>
//                           {ineligible && player.ineligibleReason && (
//                             <p className={styles.ineligibleReason}>
//                               {text.reasons[player.ineligibleReason]}
//                             </p>
//                           )}
//                         </div>
//                         {ineligible ? (
//                           <span className={styles.notEligibleBadge}>{text.notEligible}</span>
//                         ) : (
//                           <span
//                             className={player.prize ? styles.prize : styles.noPrize}
//                           >
//                             {player.prize || "—"}
//                           </span>
//                         )}
//                       </li>
//                     </React.Fragment>
//                   );
//                 })}
//               </ul>
//             )}

//             {/* ===================== MY POSITION ===================== */}
//             <div className={`${styles.myPosition} ${myIneligible ? styles.myPositionIneligible : ""}`}>
//               <div className={styles.myTop}>
//                 <svg
//                   className={styles.myIcon}
//                   viewBox="0 0 24 24"
//                   fill="currentColor"
//                   aria-hidden="true"
//                 >
//                   <circle cx="12" cy="8" r="4.5" />
//                   <path d="M3.5 21c0-4.4 3.8-7.5 8.5-7.5s8.5 3.1 8.5 7.5z" />
//                 </svg>
//                 <div className={styles.myInfo}>
//                   <p className={styles.myLabel}>{text.yourPosition}</p>
//                   <p className={styles.myValue}>
//                     {my.rank ? `${my.rank}.º` : "—"} •{" "}
//                     {formatPoints(my.points)} {text.points}
//                   </p>
//                 </div>
//                 {isWeek && my.prize && !myIneligible && (
//                   <div className={styles.myPrize}>
//                     <span className={styles.myPrizeLabel}>{text.yourPrize}</span>
//                     <span className={styles.myPrizeValue}>{my.prize}</span>
//                   </div>
//                 )}
//                 {myIneligible && (
//                   <span className={styles.notEligibleBadge}>{text.notEligible}</span>
//                 )}
//               </div>

//               {myIneligible && my.ineligibleMessage && (
//                 <p className={styles.myIneligibleMessage}>
//                   {my.ineligibleMessage[msgLang] || my.ineligibleMessage.en}
//                 </p>
//               )}
//             </div>
//           </>
//         )}
//       </div>
//     </Layouts>
//   );
// };

// export default PromoLeaderboard;








import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Layouts from "./layouts/layout";
import { getWeeklyLeaderboard, getFinalLeaderboard } from "../services/home";
import styles from "./css/promoLeaderboard.module.css";

// ===================== EMPTY DATA (until the API responds) =====================
const emptyLeaderboard = {
  week: "",
  startDate: "",
  endDate: "",
  players: [],
  myPosition: {
    rank: null,
    points: 0,
    prize: null,
    eligible: true,
    ineligibleReason: null,
    ineligibleMessage: null,
  },
  previousWeek: null,
  pastWeeks: [],
};

const TOP_LIMIT = 5;

// ===================== TEXT (0 = English, 3 = Portuguese) =====================
const leaderboardText = {
  0: {
    title: "Leaderboard",
    weekTab: "This week",
    finalTab: "Final ranking",
    week: "Week",
    weekNote: "Only this week's stars count.",
    finalNote: "Total stars across all four weeks.",
    eligibilityNote: "Weekly prizes go to eligible players only: no prizes in consecutive weeks and a maximum of 2 weekly prizes per player.",
    points: "stars",
    yourPosition: "Your position:",
    yourPrize: "Provisional prize:",
    notEligible: "Not eligible",
    reasons: {
      WON_PREVIOUS_WEEK: "Won a prize last week",
      MAX_PRIZES_REACHED: "Already won 2 weekly prizes",
    },
    movedPrizes: "Prize passed to the next eligible player",
    winnersTab: "Past winners",
    winnersTitle: "Weekly winners",
    winnersNote: "Official weekly prize winners, after the eligibility rules.",
    noWinners: "Winners will appear here when the first week ends.",
    youWon: "You won",
    youWonIn: "in week",
    you: "You",
    rankThatWeek: "Rank",
    back: "Go back",
    loading: "Loading leaderboard...",
    noPlayers: "No players yet. Play now to be the first!",
  },
  3: {
    title: "Classificação",
    weekTab: "Esta semana",
    finalTab: "Classificação final",
    week: "Semana",
    weekNote: "Contam apenas as estrelas desta semana.",
    finalNote: "Soma das estrelas das quatro semanas.",
    eligibilityNote: "Os prémios semanais vão apenas para jogadores elegíveis: sem prémios em semanas consecutivas e no máximo 2 prémios semanais por jogador.",
    points: "estrelas",
    yourPosition: "A tua posição:",
    yourPrize: "Prémio provisório:",
    notEligible: "Não elegível",
    reasons: {
      WON_PREVIOUS_WEEK: "Ganhou um prémio na semana passada",
      MAX_PRIZES_REACHED: "Já ganhou 2 prémios semanais",
    },
    movedPrizes: "Prémio passado ao próximo jogador elegível",
    winnersTab: "Vencedores",
    winnersTitle: "Vencedores semanais",
    winnersNote: "Vencedores oficiais dos prémios semanais, após as regras de elegibilidade.",
    noWinners: "Os vencedores aparecem aqui quando terminar a primeira semana.",
    youWon: "Ganhaste",
    youWonIn: "na semana",
    you: "Tu",
    rankThatWeek: "Posição",
    back: "Voltar",
    loading: "A carregar classificação...",
    noPlayers: "Ainda não há jogadores. Joga agora e sê o primeiro!",
  },
};

// formats 2840 -> "2.840" (same style as the MT amounts)
const formatPoints = (value) =>
  (value || 0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");

const avatarColors = ["#f6c6b8", "#c9d8f5", "#d6eccd", "#f3dfa8", "#e3cdf2"];

const PlayerAvatar = ({ player }) => {
  const [imgError, setImgError] = useState(false);

  if (player.avatar && !imgError) {
    return (
      <img
        src={player.avatar}
        alt=""
        className={styles.avatar}
        onError={() => setImgError(true)}
      />
    );
  }

  return (
    <span
      className={styles.avatar}
      style={{ background: avatarColors[player.rank % avatarColors.length] }}
      aria-hidden="true"
    >
      {player.name ? player.name.charAt(0) : "?"}
    </span>
  );
};

const PromoLeaderboard = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("week");
  const [weeklyLeaderboard, setWeeklyLeaderboard] = useState(emptyLeaderboard);
  const [finalLeaderboard, setFinalLeaderboard] = useState(emptyLeaderboard);
  const [loading, setLoading] = useState(true);
  const [selectedPastWeek, setSelectedPastWeek] = useState(0); // index in pastWeeks (0 = newest)
  const language = localStorage.getItem("selectedLanguage");
  const text = leaderboardText[language] || leaderboardText["0"];
  const msgLang = language === "3" ? "pt" : "en";

  // ===================== FETCH LEADERBOARDS =====================
  useEffect(() => {
    Promise.all([getWeeklyLeaderboard(), getFinalLeaderboard()])
      .then(([weeklyRes, finalRes]) => {
        if (weeklyRes?.result) setWeeklyLeaderboard(weeklyRes.result);
        if (finalRes?.result) setFinalLeaderboard(finalRes.result);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  }, []);

  const isWeek = activeTab === "week";
  const isWinners = activeTab === "winners";
  const data = isWeek || isWinners ? weeklyLeaderboard : finalLeaderboard;
  // past winners come from the weekly API (newest week first)
  const pastWeeks = weeklyLeaderboard.pastWeeks || [];
  const shownPastWeek = pastWeeks[selectedPastWeek] || null;
  // weeks where the logged-in user won a weekly prize
  const myPastWins = pastWeeks.filter((w) => w && w.myPrize);
  const players = data.players || [];
  const my = data.myPosition || emptyLeaderboard.myPosition;
  // eligibility rules apply to the weekly tab only
  const myIneligible = isWeek && my.eligible === false;

  const rankClass = (rank) => {
    if (rank === 1) return styles.rankGold;
    if (rank === 2) return styles.rankSilver;
    if (rank === 3) return styles.rankBronze;
    return styles.rankPlain;
  };

  return (
    <Layouts>
      <div className={styles.page}>
        {/* ===================== HEADER WITH BACK ARROW ===================== */}
        <div className={styles.header}>
          <button
            type="button"
            className={styles.backButton}
            onClick={() => navigate(-1)}
            aria-label={text.back}
          >
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
              aria-hidden="true"
            >
              <polyline points="15 18 9 12 15 6" />
            </svg>
          </button>
          <h2 className={styles.title}>{text.title}</h2>
        </div>

        {/* ===================== TABS ===================== */}
        <div className={styles.tabs} role="tablist">
          <button
            type="button"
            role="tab"
            aria-selected={activeTab === "week"}
            className={`${styles.tab} ${activeTab === "week" ? styles.tabActive : ""}`}
            onClick={() => setActiveTab("week")}
          >
            {text.weekTab}
          </button>
          <button
            type="button"
            role="tab"
            aria-selected={activeTab === "final"}
            className={`${styles.tab} ${activeTab === "final" ? styles.tabActive : ""}`}
            onClick={() => setActiveTab("final")}
          >
            {text.finalTab}
          </button>
          <button
            type="button"
            role="tab"
            aria-selected={activeTab === "winners"}
            className={`${styles.tab} ${activeTab === "winners" ? styles.tabActive : ""}`}
            onClick={() => setActiveTab("winners")}
          >
            🏆 {text.winnersTab}
          </button>
        </div>

        {loading ? (
          <p
            className={styles.periodNote}
            style={{ textAlign: "center", margin: "32px 0" }}
          >
            {text.loading}
          </p>
        ) : isWinners ? (
          <>
            {/* ===================== PAST WINNERS ===================== */}
            <div className={styles.period}>
              <span className={styles.winnersIcon} aria-hidden="true">🏆</span>
              <div>
                <p className={styles.periodTitle}>{text.winnersTitle}</p>
                <p className={styles.periodNote}>{text.winnersNote}</p>
              </div>
            </div>

            {pastWeeks.length === 0 ? (
              <p
                className={styles.periodNote}
                style={{ textAlign: "center", margin: "24px 0" }}
              >
                {text.noWinners}
              </p>
            ) : (
              <>
                {/* YOUR PAST WINS */}
                {myPastWins.length > 0 && (
                  <div className={styles.myWinsBanner}>
                    🎉{" "}
                    {myPastWins.map((w, i) => (
                      <span key={w.week}>
                        {i > 0 && " • "}
                        {text.youWon} <strong>{w.myPrize}</strong> {text.youWonIn} {w.week}
                      </span>
                    ))}
                  </div>
                )}

                {/* WEEK SELECTOR */}
                <div className={styles.weekChips}>
                  {pastWeeks.map((w, i) => (
                    <button
                      key={w.week}
                      type="button"
                      className={`${styles.weekChip} ${selectedPastWeek === i ? styles.weekChipActive : ""}`}
                      onClick={() => setSelectedPastWeek(i)}
                    >
                      {text.week} {w.week}
                    </button>
                  ))}
                </div>

                {shownPastWeek && (
                  <>
                    <p className={styles.winnersPeriod}>
                      {shownPastWeek.startDate} – {shownPastWeek.endDate}
                    </p>

                    {shownPastWeek.winners.length === 0 ? (
                      <p
                        className={styles.periodNote}
                        style={{ textAlign: "center", margin: "24px 0" }}
                      >
                        {text.noPlayers}
                      </p>
                    ) : (
                      <ul className={styles.list}>
                        {shownPastWeek.winners.map((winner) => (
                          <li
                            key={winner.id}
                            className={`${styles.row} ${winner.isMe ? styles.rowMe : ""}`}
                          >
                            <span
                              className={`${styles.rank} ${rankClass(winner.position)}`}
                            >
                              {winner.position}
                            </span>
                            <PlayerAvatar player={{ ...winner, rank: winner.position }} />
                            <div className={styles.playerInfo}>
                              <p className={styles.playerName}>
                                {winner.name}
                                {winner.isMe && (
                                  <span className={styles.meTag}>{text.you}</span>
                                )}
                              </p>
                              <p className={styles.playerPoints}>
                                {formatPoints(winner.points)} {text.points} • {text.rankThatWeek} {winner.rank}.º
                              </p>
                            </div>
                            <span className={styles.prize}>{winner.prize}</span>
                          </li>
                        ))}
                      </ul>
                    )}
                  </>
                )}
              </>
            )}
          </>
        ) : (
          <>
            {/* ===================== PERIOD INFO ===================== */}
            <div className={styles.period}>
              <svg
                className={styles.periodIcon}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                aria-hidden="true"
              >
                <rect x="3" y="4" width="18" height="18" rx="2" />
                <line x1="16" y1="2" x2="16" y2="6" />
                <line x1="8" y1="2" x2="8" y2="6" />
                <line x1="3" y1="10" x2="21" y2="10" />
                <line x1="8" y1="15" x2="10" y2="15" />
              </svg>
              <div>
                <p className={styles.periodTitle}>
                  {isWeek
                    ? `${text.week} ${data.week} • ${data.startDate}–${data.endDate}`
                    : `${data.startDate} – ${data.endDate}`}
                </p>
                <p className={styles.periodNote}>
                  {isWeek ? text.weekNote : text.finalNote}
                </p>
                {isWeek && (
                  <p className={styles.eligibilityNote}>ℹ️ {text.eligibilityNote}</p>
                )}
              </div>
            </div>

            {/* ===================== PLAYER LIST ===================== */}
            {players.length === 0 ? (
              <p
                className={styles.periodNote}
                style={{ textAlign: "center", margin: "24px 0" }}
              >
                {text.noPlayers}
              </p>
            ) : (
              <ul className={styles.list}>
                {players.map((player, index) => {
                  const ineligible = isWeek && player.eligible === false;
                  // divider before the first prize holder below the top 5
                  const showMovedDivider =
                    isWeek &&
                    player.rank > TOP_LIMIT &&
                    (index === 0 || players[index - 1].rank <= TOP_LIMIT);

                  return (
                    <React.Fragment key={player.id}>
                      {showMovedDivider && (
                        <li className={styles.movedDivider} aria-hidden="true">
                          <span>↓ {text.movedPrizes}</span>
                        </li>
                      )}
                      <li className={`${styles.row} ${ineligible ? styles.rowIneligible : ""}`}>
                        <span
                          className={`${styles.rank} ${rankClass(player.rank)}`}
                        >
                          {player.rank}
                        </span>
                        <PlayerAvatar player={player} />
                        <div className={styles.playerInfo}>
                          <p className={styles.playerName}>{player.name}</p>
                          <p className={styles.playerPoints}>
                            {formatPoints(player.points)} {text.points}
                          </p>
                          {ineligible && player.ineligibleReason && (
                            <p className={styles.ineligibleReason}>
                              {text.reasons[player.ineligibleReason]}
                            </p>
                          )}
                        </div>
                        {ineligible ? (
                          <span className={styles.notEligibleBadge}>{text.notEligible}</span>
                        ) : (
                          <span
                            className={player.prize ? styles.prize : styles.noPrize}
                          >
                            {player.prize || "—"}
                          </span>
                        )}
                      </li>
                    </React.Fragment>
                  );
                })}
              </ul>
            )}

            {/* ===================== MY POSITION ===================== */}
            <div className={`${styles.myPosition} ${myIneligible ? styles.myPositionIneligible : ""}`}>
              <div className={styles.myTop}>
                <svg
                  className={styles.myIcon}
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  aria-hidden="true"
                >
                  <circle cx="12" cy="8" r="4.5" />
                  <path d="M3.5 21c0-4.4 3.8-7.5 8.5-7.5s8.5 3.1 8.5 7.5z" />
                </svg>
                <div className={styles.myInfo}>
                  <p className={styles.myLabel}>{text.yourPosition}</p>
                  <p className={styles.myValue}>
                    {my.rank ? `${my.rank}.º` : "—"} •{" "}
                    {formatPoints(my.points)} {text.points}
                  </p>
                </div>
                {isWeek && my.prize && !myIneligible && (
                  <div className={styles.myPrize}>
                    <span className={styles.myPrizeLabel}>{text.yourPrize}</span>
                    <span className={styles.myPrizeValue}>{my.prize}</span>
                  </div>
                )}
                {myIneligible && (
                  <span className={styles.notEligibleBadge}>{text.notEligible}</span>
                )}
              </div>

              {myIneligible && my.ineligibleMessage && (
                <p className={styles.myIneligibleMessage}>
                  {my.ineligibleMessage[msgLang] || my.ineligibleMessage.en}
                </p>
              )}
            </div>
          </>
        )}
      </div>
    </Layouts>
  );
};

export default PromoLeaderboard;